import Features from './Features';
import RiskDefinitions from './RiskDefinitions';
import StatisticalConcepts from './StatisticalConcepts';
import Database from './Database';
import database_ from 'assets/img/landing-icons/ug-database.png';
import features_ from 'assets/img/landing-icons/ug-features.png';
import riskDefinitions_ from 'assets/img/landing-icons/ug-risk-definitions.png';
import statisticalConcepts_ from 'assets/img/landing-icons/ug-statistical-concepts.png';
import HorizontalLanding from 'components/HorizontalLanding';

export const meta = {
  path: '/ug',
  title: 'FLARE™ User Guide',
  component: Landing,
  items: [
    {
      path: '/database',
      title: 'Database',
      component: Database,
      description: 'Explore the FLARE™ proprietary database of more than 15,000 assets.',
      imgSrc: database_,
      permission: 'ug',
    },
    {
      path: '/features',
      title: 'Modules & Utilities',
      component: Features,
      description: 'Explore the FLARE™ primary modules and advanced risk and utility functions.',
      imgSrc: features_,
      permission: 'ug',
    },
    {
      path: '/risk-definitions',
      title: 'Risk Definitions',
      component: RiskDefinitions,
      description: 'Academic and practical definitions, descriptions, and interpretations for analyzing risk.',
      imgSrc: riskDefinitions_,
      permission: 'ug',
    },
    {
      path: '/statistical-concepts',
      title: 'Statistical Concepts',
      component: StatisticalConcepts,
      description: 'Descriptions and interpretations for widely used statistical techniques.',
      imgSrc: statisticalConcepts_,
      permission: 'ug',
    },
  ],
};

export default function Landing({ session }) {
  return <HorizontalLanding meta={meta} session={session} />;
}
